import { injectorData } from '~/src/features/videocontrol/data';
import type { TInjector } from '~/src/features/videocontrol/Provider/types';

export const priceForMsk = 800;
export const priceForOthers = 800;

/**
 * Проверка скидки в текущем городе
 *
 * @function
 * @name checkSaleInCity
 * @param {string} domain - домен
 * @returns {boolean}
 */
export const checkSaleInCity = (domain: string): boolean => {
    const citiesWithoutSale = ['nsk'];
    return !citiesWithoutSale.includes(domain);
};

/**
 * Получение стоимости инжектора
 *
 * @function
 * @name getPriceForInjector
 * @param {string} domain - домен
 * @returns {number}
 */
export const getPriceForInjector = (domain: string): number => {
    const citiesWithoutSale = ['msk'];
    return citiesWithoutSale.includes(domain) ? priceForMsk : priceForOthers;
};

/**
 * Получение данных инжектора
 *
 * @function
 * @name getInjectorData
 * @param {string} domain - домен
 * @returns {TInjector}
 */
export const getInjectorData = (domain: string): TInjector => {
    return {
        ...injectorData,
        priceTotalWithCount: getPriceForInjector(domain),
        priceTotal: getPriceForInjector(domain),
    };
};
